export enum enum_ErrorMessages {
  'ERRORMESSAGE_403' = '403 - permission denied',
  'ERRORMESSAGE_404' = '404 - page not found',
  'ERRORMESSAGE_500' = '500 - service unavailable'
};
